import { ArrowRight } from "lucide-react";
import { FaCheck } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import styled from "styled-components";

export const Background = styled.div`
    width: 100%;
    padding: 32px 8px;
`;

export const Container = styled.div`
    position: relative;
    padding: 24px 16px;
    @media (min-width: 1024px) {
        width: 50%;
        margin-left: auto;
        margin-right: auto;
    }
    @media (min-width: 1440px) {
        width: 45%;
        margin-left: auto;
        margin-right: auto;
    }
    border-radius: 32px;
    padding: 32px;
    .petrol-700 & {
        background-color: rgb(7, 63, 71);
    }
    .orange-50 & {
        background-color: #fff;
        border: 1px solid #dedede;
    }
`;

export const Headline = styled.h2`
    font-size:  var(--font-size-header-medium);
    margin-bottom: 14px;
`;

export const Subtitle = styled.p`
    font-size: 18px;
    margin-bottom: 24px;
`;

export const ProductName = styled.p`
    width: 100%;
    font-weight: 600;
    cursor: pointer;
    display: block;
    margin-bottom: 4px;
    line-height: 1em;
    .petrol-700 & {
        color: var(--color-coal);
    } 
`;

// ${({productTargetVariant}) => productTargetVariant === "fagforeningloensikring" && `
//         display: block;`
//     }

export const ProductCardContainer = styled.div`
    margin-bottom: 28px;
`;

export const ProductCard = styled.div<{checked: boolean | undefined, isSelfemployeedPackage: boolean}>`
    width: 100%; 
    font-size: 18px;
    border: ${({checked }) => (checked ? "0px" : "1px solid #DEDEDE")};
    outline: ${({checked }) => (checked ? "2px solid var(--color-orange)" : "none")};
    &:hover {
        outline: 2px solid var(--color-orange);
    }
    border-radius: 12px;
    background-color: #ffffff;
    .orange-50 & {
        background-color: #fdf8f5;
    }
    position: relative;
    margin-bottom: 16px;
    cursor: pointer;
`;

export const TopContainerCard = styled.div`
    padding: 16px 12px;
`;

export const SalaryinsuranceInfoLabel = styled.div`
    text-align: center;
    border-bottom-right-radius: 12px;
    border-bottom-left-radius: 12px;
    padding: 8px 0px;
    font-size: 16px;
    display: flex;
    justify-content: center;
    .petrol-700 & {
        background-color: var(--color-orange-50);
        color: var(--color-orange-700);
    }
    .orange-50 & {
        background-color: #fbeade;
        color: var(--color-orange-700);
    }
`;

export const Arrow = styled(ArrowRight)`
   padding-left: 8px;
`;

export const CardContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: end;
    @media (min-width: 768px) {
        align-items: center;
        justify-content: space-between;
        flex-direction: row;
    }
`;

export const CardContainerLeft = styled.div`
    display: flex;
`;

export const InputContainer = styled.div<{productTargetVariant?: string}>`
    padding-left: 40px;
`;

export const Price = styled.p<{ strikeThrough?: boolean | undefined, productTargetVariant?: string}>`
    font-weight: 600;
    margin-bottom: 0px;
    white-space: nowrap;
    span {
        font-weight: 500;
        color: #7B7B7A;
    }
    text-decoration: ${({ strikeThrough }) => (strikeThrough ? "line-through" : "none")};
      ${({productTargetVariant}) => productTargetVariant === "fagforeningloensikring" && `
        margin-top: 8px;`
    }
    .petrol-700 & {
        color: var(--color-coal);
    }
    @media (min-width: 768px) {
        font-size: 18px;
    }
`;

export const Label = styled.label`
    width: 0;
    display: none;
`;

export const Input = styled.input`
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
`;

export const CustomInput = styled.span <{ checked: boolean | undefined }>`
    position: absolute;
    height: 30px;
    width: 30px;
    background-color: ${({ checked }) => (checked ? "var(--color-orange)" : "#fff")};
    border: ${({ checked }) => (checked ? "2px solid var(--color-orange)" : "2px solid #cccccc")};
    cursor: pointer;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Checked = styled(FaCheck)`
    color: #ffffff;
`;

export const UnorderedList = styled.ul`
    padding-left: 0px;
`;

export const InfoLi = styled.li`
    color: #7B7B7A;
    margin-bottom: 4px;
    font-size: 16px;
    &::marker {
        color: var(--color-orange)
    }
`;

export const TotalText = styled.p`
    margin-bottom: 0px;
    font-size: 14px;
`;

export const TotalPriceContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    @media (min-width: 1024px) {
        flex-direction: row;
        align-items: end;
        justify-content: space-between;
    }
`;

export const TotalPrice = styled.p`
    font-weight: 600; 
    margin-bottom: 0px;
    font-size: 32px;
    line-height: 1.1em;
    span {
        font-size: 16px;
    }
`;

export const Button = styled.a<{ active?: boolean | undefined }>`
    background-color: ${({ active }) => (!active ? "#cccccc" : "var(--color-orange)")} ;
    color:  var(--color-white);
    font-size: 18px;
    font-weight: var(--font-weight-bold);
    border-radius: 35px;
    padding: 16px 44px;
    text-decoration: none;
    display: block;
    text-align: center;
    disabled: ${({ active }) => (!active ? "true" : "false")};
    pointer-events: ${({ active }) => (!active ? "none" : "auto")};
`;

export const PackageContainer = styled.div<{isPackage: boolean}>`
    border: ${({ isPackage }) => (isPackage ? "3px solid var(--color-petrol)" : "0px")};
    border-top-right-radius: ${({ isPackage }) => (isPackage ? "12px" : "0px")};
    border-top-left-radius: ${({ isPackage }) => (isPackage ? "12px" : "0px")};
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
`;


export const LeadSuccessInfo = styled.p`
    font-size: 14px;
    margin-top: 16px;
    display: flex;
    justify-content: end;
`;

export const PackageToast = styled.div`
    @keyframes slideInFromRight {
        from {
            transform: translateX(100%);
            opacity: 0;
        }
        to {
            transform: translateX(0);
            opacity: 1;
        }
    }

    position: fixed;
    top: 50%;
    right: 16px;
    left: 16px;
    width: auto;
    background-color: #fff;
    color: var(--color-coal);
    border-radius: 12px;
    border-left: 5px solid var(--color-ase-orange);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
    z-index: 1000;
    animation: slideInFromRight 0.6s ease-out;

    /* Tablet: not enough margin space to sit beside the container. Container is 50vw wide here, so -25vw
       reaches the window's right edge while staying position:absolute (scrolls with the module, not the viewport) */
    @media (min-width: 1024px) and (max-width: 1439px) {
        position: absolute;
        top: 0;
        bottom: auto;
        left: auto;
        right: calc(-25vw + 16px);
        width: 300px;
    }

    /* Desktop: enough margin space to sit beside the container, never inside it */
    @media (min-width: 1440px) {
        position: absolute;
        top: 0;
        bottom: auto;
        left: 100%;
        right: auto;
        margin-left: 24px;
        width: 340px;
    }
`;

export const PackageToastHeader = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 8px 9px 4px 20px;
    border-top-right-radius: inherit;
    border-top-left-radius: inherit;
    align-items: start;
`;

export const CloseIcon = styled(IoClose)`
    color: var(--color-coal-50);
    width: 20px;
    height: 20px;
    cursor: pointer;
    margin-left: 8px;
}
`;

export const PackageToastTitle = styled.p`
    font-size: 14px;
    font-weight: var(--font-weight-bold);
    margin: 0px;
    clear: both;
`;

export const PackageToastContainer = styled.div`
    padding: 0px 20px 13px 20px;
`;

export const PackageToastContent = styled.p`
    font-size: 13px;
    line-height: 1.4em;
    margin: 0;
`;

export const PackageToastContentSmall = styled.p`
    font-size: 12px;
    line-height: 1.4em;
    margin: 0;
    font-style: italic;
    padding-top: 10px;
`;

export const PackageToastLink = styled.a`
    color: var(--color-coal);
    font-size: 13px;
`;

export const PackageToastCTA = styled.a`
    margin-top: 12px;
    padding: 5px 14px;
    font-weight: 500;
    font-size: 13px;
    margin-right: 16px;
    background-color: rgb(255, 255, 255);
    border: 1px solid var(--color-orange-700);
    color: var(--color-orange-700);
`;

export const OfferLabelToast = styled.div`
    padding: 5px 11px;
    border-radius: 8px;
    background-color: var(--color-orange-50);
    color: var(--color-orange-700);
    font-size: 13px;
    display: inline-block;
    margin-left: 20px;
    margin-top: 4px;
`;

export const StarIcon = styled.img`
    width: 35px;
    height: 35px;
    margin-right: 14px;
    animation: starPulse 1.8s ease-in-out infinite;

    @keyframes starPulse {
        0%, 100% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.12);
        }
    }
`;

export const InlineToast = styled.div`
    padding-bottom: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const InlineToastLink = styled.a`
   text-decoration: underline;
`;
